import { HowItWorksMockKind } from "@/app/types/home/HowItWorksBlock";
import HowItWorksMockAssistant from "./HowItWorksMockAssistant";
import HowItWorksMockCapture from "./HowItWorksMockCapture";
import HowItWorksMockConnectors from "./HowItWorksMockConnectors";
import HowItWorksMockCustomerFile from "./HowItWorksMockCustomerFile";
import HowItWorksMockPersona from "./HowItWorksMockPersona";

type Props = {
  kind: HowItWorksMockKind;
};

export default function HowItWorksMock(props: Props) {
  const { kind } = props;

  if (kind === HowItWorksMockKind.CAPTURE) {
    return <HowItWorksMockCapture />;
  }
  if (kind === HowItWorksMockKind.CUSTOMER_FILE) {
    return <HowItWorksMockCustomerFile />;
  }
  if (kind === HowItWorksMockKind.PERSONA) {
    return <HowItWorksMockPersona />;
  }
  if (kind === HowItWorksMockKind.CONNECTORS) {
    return <HowItWorksMockConnectors />;
  }
  return <HowItWorksMockAssistant />;
}
